/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const DownloadFormatter = (
  cellContent,
  row,
  rowIndex,
) => (

  <>
    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Proses Data</Tooltip>}
    >
      <a
        className="btn btn-success "
        onClick={() => window.open(row.url_path)}

      >{row.id}
        {/* <span className="svg-icon svg-icon-md svg-icon-primary"> */}
        {/* </span> */}
        Download
      </a>
    </OverlayTrigger>

    <> </>
    {/*<OverlayTrigger*/}
    {/*    overlay={<Tooltip id="products-delete-tooltip">Delete product</Tooltip>}*/}
    {/*>*/}
    {/*    <a*/}
    {/*        className="btn btn-icon btn-light btn-hover-danger btn-sm"*/}
    {/*        // onClick={() => console.log('deleted id : ',row.uuid)}*/}
    {/*    >*/}
    {/*<span className="svg-icon svg-icon-md svg-icon-danger">*/}
    {/*  <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>*/}
    {/*</span>*/}
    {/*    </a>*/}
    {/*</OverlayTrigger>*/}
  </>
);
